$(document).ready(function () {
    // #region Login/Register Page
    $(document).on("submit", "form.UyeOlModal, form.UyeGirisModal", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        var email = $('#login_UserName').val(); // E-posta adresini al

        UserForms(form, function (dt) {
            if (dt.Sonuc == true) {

                //kullanıcı login olurken gönderilen gtag
                dataLayer.push({
                    'event': 'custom_event',
                    'event_category': 'membership',
                    'event_action': 'login',
                    'email': email
                });
                //login gtag son 

                //Login
                dataLayer.push({
                    event: "vlEvent",
                    vl_label: "VL-Login",
                    vl_userID: email
                });

                if (dt.JsonRs == "Reload") {
                    $(".RwRegisterLogin").hide();
                    document.location.reload();
                }
                else if (dt.JsonRs == "Redirect") {
                    $(".RwRegisterLogin").hide();
                    document.location = dt.Deger5;
                }
                else if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                    document.location = $("#register_FbRedirectUrl").val();
                }
                else {
                    GenerateLocalLoading(form, "hide");
                }
            }
            else {
                var errorMsg = dt.IslemSonucAciklama;

                if (errorMsg == "" || errorMsg == null) {
                    errorMsg = dt;
                }

                SwalGenerate("error", errorMsg, "İşlem Başarısız", "Tekrar Dene");
                GenerateLocalLoading(form, "hide");
            }
        });

        return false;
    });

    $(document).on("keyup", "form.UyeOlModal input#register_UserName", function () {
        var thisValue = $(this).val();

        thisValue = thisValue.replaceAll(" ", "");
        thisValue = thisValue.toLowerCase();
        thisValue = thisValue.turkishtoEnglish();

        $(this).val(thisValue);
    });

    $(document).on("click", ".ForgetPass", function (e) {
        $("#forgottenpassModal").find("input").val("");
        $("#forgottenpassModal").modal('show');
    });

    $(document).on("submit", "form.ForgettenForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        UserForms(form, function (dt) {
            if (dt.Sonuc == true) {
                $("#forgottenpassModal").modal('hide');
                SwalGenerate("success", dt.IslemSonucAciklama, "İşlem Başarılı", "Kapat");
            }
            else {
                var errorMsg = dt.IslemSonucAciklama;

                if (errorMsg == "" || errorMsg == null) {
                    errorMsg = dt;
                }

                SwalGenerate("error", errorMsg, "İşlem Başarısız", "Tekrar Dene");
            }

            GenerateLocalLoading(form, "hide");
        });

        return false;
    });

    $(document).on("click", "#SingOut", function () {

        //kullanıcı logout olduğu zaman gtag
        dataLayer.push({
            'event': 'custom_event',
            'event_category': 'membership',
            'event_action': 'logout'
        });
        //kullanıcı logout gtag end

        if (!isAppleMobile()) {
            localStorage.removeItem("LastVisitedPrds");
        }
    });
    // #endregion Login/Register Page

    // #region MyAcount
    $(document).on("submit", "form.UserInfoForm, form.ChangePassForm, form.AdresForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        AccountAjaxForms(form, function (status, message) {
            if (status == true) {
                if (form.hasClass("AdresForm")) {
                    $("#AddressAddModal").modal("hide");
                    GetAddressList();
                }

                SwalGenerate("success", message, "İşlem Başarılı", "Kapat");
            }
            else {
                SwalGenerate("error", message, "İşlem Başarısız", "Tekrar Dene");
            }

            GenerateLocalLoading(form, "hide");
        });

        return false;
    });

    $(document).on("click", ".FollowItems .FollowListItems .DeleteFollowItem", function () {
        var id = $(this).attr("data-id");
        var LangID = $("#LangID").val();
        RemoveElement = $(this).parents(".FollowListItems");

        GenerateLocalLoading(RemoveElement, "show");

        DeleteFollowItem(id, LangID, function (status, message) {
            if (status) {
                RemoveElement.remove();
            }
            else {
                SwalGenerate("error", message, "İşlem Başarısız", "Tekrar Dene");
                GenerateLocalLoading(RemoveElement, "hide");
            }
        });
    });

    $(document).on("change", ".adrestipradio", function () {
        if ($("#AdresTipi2").is(":checked")) {
            $(".vergi").show("slow");
        }
        else {
            $(".vergi").hide("slow");
        }
    });

    // #region Orders
    //$(document).on("click", ".MyOrders .MyOrdersItem .OpenOrderDetail", function () {
    //    //var Url = $(this).attr("data-href");
    //    var trackCode = $(this).attr("data-track");
    //    var Url = "/" + $("#SmallLangCode").val() + '/p/Orders/Details?TrackCode=' + trackCode;

    //    Modal = $("#UserOrderModal");
    //    ModalHideEvent(Modal, ".modal-content");

    //    if (trackCode != null && trackCode != "" && trackCode != undefined) {
    //        $orderDetailModalUrl = Url;

    //        Modal.modal("show");
    //        GenerateLocalLoading(Modal.find(".modal-dialog"), "show");

    //        GetUserOrderDetails(Url, function (data) {
    //            Modal.find(".modal-content").html(data);
    //            GenerateLocalLoading(Modal.find(".modal-dialog"), "hide");
    //        });
    //    }
    //});

    $(document).on("click", ".cargoTrackButton", function () {
        Modal = $("#CargoTrackModal");
        var trackPage = $(this).attr("data-url");

        if (trackPage != null && trackPage != "" && trackPage != undefined) {
            iframe = Modal.find(".modal-body .CargoTrackPage");
            iframe.attr("src", trackPage);
            iframe.css("width", "100%");
            iframe.css("height", $(window).height() - 200);

            Modal.modal("show");
        }
    });

    $(document).on("click", ".MoneyTransferInfo", function () {
        var trackCode = $(this).attr("data-trackCode");

        if (trackCode != null && trackCode != "" && trackCode != undefined) {
            GenerateLocalLoading(Modal.find(".MoneyTransferContainer"), "show");

            GetMoneyTransferInfoForm(trackCode, function (status, data) {
                if (status) {
                    Modal.find(".MoneyTransferContainer").html(data);
                }
                else {
                    SwalGenerate("error", data, "İşlem Başarısız", "Tekrar Dene");
                }

                GenerateLocalLoading(Modal.find(".MoneyTransferContainer"), "hide");
            });
        }
    });

    $(document).on("submit", ".MoneyTransferContainer .MoneyTransferForm", function () {
        form = $(this);

        GenerateLocalLoading(form, "show");

        AccountAjaxForms(form, function (status, message) {
            if (status == true) {
                SwalGenerate("success", message, "İşlem Başarılı", "Kapat");

                form.closest(".MoneyTransferContainer").html("");
            }
            else {
                SwalGenerate("error", message, "İşlem Başarısız", "Tekrar Dene");
            }

            GenerateLocalLoading(form, "hide");
        });

        return false;
    });

    // #region ReturnProduct
    $(document).on("click", ".productOperations .ReturnProduct", function () {
        var orderedItemsID = $(this).attr("data-id");
        var ItemRow = $(this).closest(".SepetRow");

        if (orderedItemsID) {
            GenerateLocalLoading(ItemRow, "show");

            GetRetOrdersForm(orderedItemsID, function (status, data) {
                if (status) {
                    ItemRow.find(".ReturnProductReason").html(data);
                }
                else {
                    SwalGenerate("error", data, "İşlem Başarısız", "Tekrar Dene");
                }

                GenerateLocalLoading(ItemRow, "hide");
            });
        }
    });

    $(document).on("submit", ".ReturnProductReason .RetOrderForm", function () {
        form = $(this);
        var ItemRow = $(this).closest(".SepetRow");
        GenerateLocalLoading(ItemRow, "show");

        AccountAjaxForms(form, function (status, message) {
            GenerateLocalLoading(ItemRow, "hide");

            if (!status) {
                SwalGenerate("error", message, "İşlem Başarısız", "Tekrar Dene");
                return false;
            }

            SwalGenerate("success", message, "İşlem Başarılı", "Kapat");
            ItemRow.find(".ReturnProductReason").html("");
            ItemRow.find(".ReturnProductContainer").html("");
        });

        return false;
    });

    $(document).on("click", ".ReturnProductReason .btn.cancel", function () {
        var ItemRow = $(this).closest(".SepetRow");
        ItemRow.find(".ReturnProductReason").html("");
    });
    // #endregion

    // #endregion

    // #region Address
    $(document).on("click", ".NewAddressContent .NewAddress", function () {
        AddressModal = $("#AddressAddModal");

        AddressModal.modal({
            backdrop: false
        });

        AddressModal.modal("show");
        ModalHideEvent(AddressModal, ".modal-body");

        GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

        GetPartialAdress(AddressModal);
    });

    $(document).on("click", ".MyAddress .AddressContainer .AddressBox .AddressOperation .AddressEdit", function () {
        AddressModal = $("#AddressAddModal");

        AddressModal.modal({
            backdrop: false
        });

        $("body").css("overflow", "auto");

        var id = $(this).attr("data-id");

        if (id != undefined && id != "" && id > 0) {
            AddressModal.modal("show");
            ModalHideEvent(AddressModal, ".modal-body");
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

            var EditUrl = "/" + $("#SmallLangCode").val() + "/p/User/AdressEdit/" + id;

            GetPartialAdress(AddressModal, EditUrl);
        }
        else {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });

    $(document).on("click", ".MyAddress .AddressContainer .AddressBox .AddressOperation .AddressDelete", function () {
        var id = $(this).attr("data-id");
        var AddressContainer = $(this).parents(".AddressContainer");

        if (id != undefined && id != "" && id > 0) {
            DeleteAddress(id, AddressContainer);
        }
        else {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });

    $(document).on("click", "#AddressAddModal .FormButtons .btn-cancel", function () {
        $("#AddressAddModal").modal("hide");
    });

    $(document).on("change", "#AddressAddModal .ddl_sehir", function () {
        AddressModal = $("#AddressAddModal");
        var seciliSehirOID = $(this).val();

        if (seciliSehirOID != undefined && seciliSehirOID != "") {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

            GetDistrict(seciliSehirOID);
        }
        else {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
            $('#TownID option:gt(0)').remove();
        }
    });

    $(document).on("change", "#AddressAddModal .ddl_ilce", function () {
        AddressModal = $("#AddressAddModal");
        var seciliIlceID = $(this).val();

        if (seciliIlceID != undefined && seciliIlceID != "") {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

            GetQuarters(seciliIlceID);
        } else {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
            $('#QuarterID option:gt(0)').remove();
        }
    });
    // #endregion Address

    // #region Messages
    $(document).on("click", ".UserMessage .UserMessageList #UserMessages tbody tr, .UserMessage .NewItemPlus .NewMessageButton", function () {
        var id = $(this).attr("data-id");

        if (id != null && id != "" && id != undefined) {
            var url = "/" + $("#SmallLangCode").val() + "/p/User/MessageDetail?id=" + id;

            GetMessageDetail(url);

            if ($(this).hasClass("UnreadMessage")) {
                $(this).removeClass("UnreadMessage");
            }
        }
    });

    $(document).on("submit", "form.UserMessageForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        var IsNewMessage = false;
        var MessageID = $(".AddMessageContainer #UserMessageID").val();
        if (MessageID == null || MessageID == undefined || MessageID == "" || MessageID <= 0) {
            IsNewMessage = true;
        }

        AddNewUserMessage(form, IsNewMessage);

        return false;
    });
    // #endregion
    // #endregion MyAcount

    $('.ToggleAccountMenu').click(function () {
        $(".AccountMenu").toggleClass("open");
    });

    $(document).on("submit", "form.ContactForm", function (e) {
        form = $(this);
        GenerateLocalLoading(form, "show");

        AccountAjaxForms(form, function (status, message) {
            $(".ContactForm #Subject").val("");
            $(".ContactForm #Message").val("");

            if (status) {
                SwalGenerate("success", message, "İşlem Başarılı", "Kapat");
            }
            else {
                SwalGenerate("error", message, "İşlem Başarısız", "Tekrar Dene");
            }

            GenerateLocalLoading(form, "hide");
        });

        e.preventDefault();
        return false;
    });

    //$(document).on("submit", "form.MyOrderNotMember", function (e) {
    //    form = $(this);
    //    GenerateLocalLoading(form, "show");

    //    MyOrderNotMember(form);

    //    e.preventDefault();
    //    return false;
    //});

    SendConfirmCode();
    SendConfirmCodeUserInfo();
    ChangePhoneNumber();
    SetCurrentMenuItem();
    PhoneFormatAccount();

    $("#RegisterConfirmButton").click(function () {

        var email = $('input[name="register.UserName"]').val(); // E-posta adresini al

        $("#RegisterConfirmButton").attr('disabled', 'disabled');

        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/User/UserAdd",
            data: $(".UyeOlModal").serialize(),
            success: function (re) {

                $("#RegisterConfirmButton").removeAttr('disabled');

                if (re.Sonuc == true) {

                    //register olurken push edilecek gtag
                    dataLayer.push({
                        'event': 'custom_event',
                        'event_category': 'membership',
                        'event_action': 'sign_up',
                        'email': email
                    });
                    //register olurken gtag end

                    // Signup
                    dataLayer.push({
                        event: "vlEvent",
                        vl_label: "VL-Signup",
                        vl_userID: email
                    });

                    if (re.JsonRs == "Redirect") {
                        window.location.assign("/");
                    }
                } else if (re.JsonRs == "FailConfirmCode") {
                    SwalGenerate("error", re.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");

                } else {
                    SwalGenerate("error", re.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                    $("#confimCodeModal").modal("hide");
                    $("#ConfirmCode").val("");
                }
            },
            error: function () {
                $("#RegisterConfirmButton").removeAttr('disabled');
            }
        });
    });

    $(document).on("click", ".MyCardsTable .UserCardItem", function () {

        var cardToken = $(this).attr("data-cardToken");

        var cardUserKey = $("#CardUserKey").val();

        if (window.confirm("Seçili kartı silmek istediğinize emin misiniz?")) {

            DeleteUserCard(cardUserKey, cardToken);
        }
    });

    if ($('#MobileRegisterPopup').length > 0 && $('body').hasClass("LoginPage") && $(window).width() < 992) {

        //var registerPopupCookieKey = 'RegisterModalShow';

        //var registerPopupCookieValue = 'YES';

        //if (typeof getCookie(registerPopupCookieKey) == "undefined") {

        if ($(window).width() < 992) {
            $('#MobileRegisterPopup').modal("show");
        }
        else {
            $('#MobileRegisterPopup').modal("hide");
        }

        //setCookie(registerPopupCookieKey, registerPopupCookieValue);
        //}
    }
});

function PhoneFormatAccount() {

    // Burada seçilmiş olan bölgeye göre telefon için uygulanan maske değişecek
    var selectedLangCode = $("#LangChange option:selected").data("langcode");
    var phoneMask = "999 999 99 99";

    switch (selectedLangCode) {
        case "tr":
            phoneMask = "999 999 99 99";
            break;
        case "az":
            phoneMask = "99 999 9999";
            break;
    }

    $("#localPassVM_User_Gsm").mask(phoneMask, {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    // Telefon formatlamaya 3 marttaki yönetim toplantısında gerek olmadığı söylendi
    $("#Phone2").mask(phoneMask, { placeholder: "Telefon" }, {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    $("#register_Gsm").mask(phoneMask, {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    $('#localPassVM_User_Gsm').keypress(function (e) {
        if (this.value.length == 0 && e.which == 48) {
            $(".help-block").fadeIn('slow').fadeOut('slow');
            return false;
        }
    });

    $('#Phone2').keypress(function (e) {
        if (this.value.length == 0 && e.which == 48) {
            $(".help-block").fadeIn('slow').fadeOut('slow');
            return false;
        }
    });

    $('#register_Gsm').keypress(function (e) {
        if (this.value.length == 0 && e.which == 48) {
            $(".help-block").fadeIn('slow').fadeOut('slow');
            return false;
        }
    });
}

function SetCurrentMenuItem() {
    if (document.URL.indexOf("/p/User/") > -1 || document.URL.indexOf("/p/Orders/") > -1) {
        $(".grey .menuitem a").each(function (index) {
            var CurUrl = document.URL.split('/p/User/')[1];
            var CurLink = "";

            if (document.URL.indexOf("/p/Orders/") > -1) {
                CurUrl = document.URL.split('/p/Orders/')[1];
                CurLink = $("#SmallLangCode").val() + "/p/Orders/" + $("#AName").val();
            }
            else {
                CurLink = $("#SmallLangCode").val() + "/p/User/" + $("#AName").val();
            }

            if ($(this).attr("href").indexOf(CurLink) > 0) {

                if ($(this).attr("href").indexOf("hb=t") < 0) {
                    $(this).closest("li").addClass("current");

                }
                else if ($(this).attr("href").indexOf("hb=t") > 0 && document.URL.indexOf("hb=t") > -1) {
                    $(".grey li").removeClass("current");
                    $(this).closest("li").addClass("current");
                }
            }
        });

        $(".ToggleAccountMenu").html($(".menuitem.current:first").text() + "<span></span>");

        if ($(".menuitem.current:first").length <= 0) {
            $(".ToggleAccountMenu").html($(".menuitem:first").text() + "<span></span>");
        }
    }
}

function SendConfirmCode() {
    $("#ConfirmPhoneBtn").click(function () {
        var userName = $("input[name='register.UserName']").val();
        var name = $("input[name='register.Name']").val();
        var gsm = $("input[name='register.Gsm']").val();
        var password = $("input[name='register.Password']").val();
        var confimrPassword = $("input[name='register.ConfirmPassword']").val();
        var isAllowKvkk = $("input[name='register.AllowTerms']").is(':checked')

        //console.log("userName: ", userName);
        //console.log("name: ", name);
        //console.log("gsm: ", gsm);
        //console.log("password: ", password);
        //console.log("confimrPassword: ", confimrPassword);
        //console.log("isAllowKvkk: ", isAllowKvkk);
        //console.log("encodeURI(password): " + encodeURI(password));
        //console.log("encodeURIComponent(password): " + encodeURIComponent(password));

        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/User/PasswordValidator",
            data: 'password=' + encodeURIComponent(password),
            success: function (dt) {

                // console.log("SONUC: " + JSON.stringify(dt));

                if (dt.Sonuc == true) {

                    if (userName != "" &&
                        name != "" &&
                        userName != "" &&
                        gsm != "" &&
                        password != "" &&
                        confimrPassword != "" &&
                        isAllowKvkk == true) {

                        if (gsm != "" && gsm != null && gsm != undefined/* && gsm.length == 13*/) {

                            GenerateLocalLoading($("body"), "show");

                            $.ajax({
                                type: "POST",
                                url: "/" + $("#SmallLangCode").val() + "/p/User/SendConfirmCode",
                                data: 'Gsm=' + gsm,
                                success: function (dt) {
                                    if (dt.Sonuc == true) {
                                        if (dt.IslemSonucAciklama === "Telefon numarası zaten onaylı.Doğrulama adımları tamamlanmıştır.İşlemi tamamlayabilirsiniz.") {
                                            // Sistemde telefonu kayıtlı ve onaylı olan kullanıcılar üye kayıdı oluşturmak istediği zaman
                                            $.ajax({
                                                type: "POST",
                                                url: "/" + $("#SmallLangCode").val() + "/p/User/UserAdd",
                                                data: $(".UyeOlModal").serialize(),
                                                success: function (re) {
                                                    if (re.Sonuc == true) {
                                                        if (re.JsonRs == "Redirect") {
                                                            window.location.assign("/");
                                                        }
                                                    } else {
                                                        GenerateLocalLoading($("body"), "hide");
                                                        SwalGenerate("error", re.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                                                    }
                                                }
                                            });
                                        } else {
                                            GenerateLocalLoading($("body"), "hide");
                                            $("#ConfirmCodeAlert").html(gsm + " Numaralı hatta onay kodu gönderilmiştir.")
                                            $("#ConfirmCodeAlert").addClass("alert-success");
                                            $("#confimCodeModal").modal('show');
                                        }
                                    }
                                    else {
                                        SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                                        GenerateLocalLoading($("body"), "hide");
                                    }
                                },
                                error: function () {
                                    SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Tekrar Dene");
                                }
                            });
                        }

                        else {
                            SwalGenerate("error", "Lütfen Telefon numaranızı 10 hane olacak şekilde giriniz.", "İşlem Başarısız", "Tekrar Dene");
                        }
                    } else {

                        SwalGenerate("error", "Lütfen tüm alanları doldurunuz , Kullanım Şartları ve Gizlilik Sözleşmesini onaylayınız.", "İşlem Başarısız", "Tekrar Dene");
                    }
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                    GenerateLocalLoading($("body"), "hide");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Tekrar Dene");
            }
        });



    });
}

function SendConfirmCodeUserInfo() {
    $("#ConfirmPhoneBtnUserInfo").click(function () {
        var gsm = $("input[id='register_Gsm']").val();

        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/User/SendConfirmCode",
            data: 'Gsm=' + gsm,
            success: function (dt) {
                if (dt.Sonuc == true) {

                    if (dt.IslemSonucAciklama == "Telefon numarası zaten onaylı.Doğrulama adımları tamamlanmıştır.İşlemi tamamlayabilirsiniz.") {
                        GenerateLocalLoading($("body"), "hide");
                        SwalGenerate("success", dt.IslemSonucAciklama, "İşlem Gerçekleştirildi", "Tamam");
                        $("#ChangePhoneNumber").prop('disabled', false);
                    }
                    else {

                        GenerateLocalLoading($("body"), "hide");
                        SwalGenerate("success", dt.IslemSonucAciklama, "İşlem Gerçekleştirildi", "Tamam");
                        $("#ConfirmCode").removeClass("gizle");
                        $("#ChangePhoneNumber").prop('disabled', false);
                    }

                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                    GenerateLocalLoading($("body"), "hide");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    });

}

function ChangePhoneNumber() {
    $("#ChangePhoneNumber").click(function () {
        var gsm = $("#register_Gsm").val();
        var userName = $("#User_UserName").val();
        var confirmCode = $("#ConfirmCode input").val();
        if (gsm != "" && gsm != null && gsm != undefined && gsm.length == 13) {
            $.ajax({
                type: "POST",
                url: "/" + $("#SmallLangCode").val() + "/p/User/ChangePhoneNumber",
                data: 'Gsm=' + gsm + "&UserName=" + userName + "&ConfirmCode=" + confirmCode,
                success: function (dt) {
                    if (dt.Sonuc == true) {

                        SwalGenerate("success", dt.IslemSonucAciklama, "İşlem Başarılı", "Kapat");
                        $("#ConfirmPhoneBtn").prop('disabled', false);
                        $("#ChangePhoneNumber").prop('disabled', true);
                    }
                    else {
                        SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                    }
                },
                error: function () {
                    SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Tekrar Dene");
                }

            });
        } else {
            SwalGenerate("error", "Lütfen Telefon numaranızı 10 hane olacak şekilde giriniz", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}

function DeleteCard(CardUserKey, CardToken) {
    if (CardToken != undefined && CardToken != null && CardUserKey != undefined && CardUserKey != null) {
        $.ajax({
            type: 'POST',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/UserCardDelete?cardUserKey=" + encodeURIComponent(CardUserKey) + "&cardToken=" + encodeURIComponent(CardToken),
            cache: false,
            async: true,
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    SwalGenerate("success", dt.ResultDescription, "İşlem Başarılı", "Kapat");
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    }
}